export default {
  "content": "<title>American Football</title><ellipse cx=\"256\" cy=\"256\" rx=\"267.57\" ry=\"173.44\" transform=\"rotate(-45 256 256.002)\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M334.04 177.96L177.96 334.04M278.3 278.3l-44.6-44.6m89.19 0l-44.59-44.59m178.38 22.29L300.6 55.32m-89.2 401.36L55.32 300.6m178.38 22.29l-44.59-44.59\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};